import { findParentNodeOfType } from 'prosemirror-utils';
export function changeNestedList(listType) {
  return function (state, dispatch) {
    let {
      nodes
    } = state.schema;
    let closestNestedList = findParentNodeOfType([nodes.orderedNestedList, nodes.unorderedNestedList])(state.selection);
    if (!closestNestedList) {
      return false;
    }
    if (closestNestedList.node.type !== listType) {
      if (dispatch) {
        dispatch(state.tr.setNodeMarkup(closestNestedList.pos, listType).scrollIntoView());
      }
      return true;
    }
    return false;
  };
}